import { isNotUndefined } from 'infrastructure/functions';

import {
  genThresholdText,
  croOrDncText,
  uniqueDaysTextWithType,
  additionalFollowUpText,
  needEscalateText,
  readingInTargetRangeText,
} from '../helpers';

import type { TMaBloodPressureGreenDataOptional } from '../../types';

export const bloodPressure = (data: TMaBloodPressureGreenDataOptional) => {
  let text = '';

  const thresholdTextSystolic = genThresholdText(
    'systolic',
    data.systolicAvg,
    data.systolicAvg30days,
    data.systolicAvg90days,
  );
  if (thresholdTextSystolic.trim()) text += `${thresholdTextSystolic}`;

  const thresholdTextDiastolic = genThresholdText(
    'diastolic',
    data.diastolicAvg,
    data.diastolicAvg30days,
    data.diastolicAvg90days,
  );
  if (thresholdTextDiastolic.trim()) text += `\n${thresholdTextDiastolic}`;

  const thresholdTextPulse = genThresholdText(
    'pulse',
    data.pulseAvg,
    data.pulseAvg30days,
    data.pulseAvg90days,
  );
  if (thresholdTextPulse.trim()) text += `\n${thresholdTextPulse}`;

  const inTargetRangeText = readingInTargetRangeText(
    data.bpAndPulseWithinRange,
    data.bpAndPulseWithinRangeComment,
  );
  if (inTargetRangeText.trim()) text += `\n${inTargetRangeText}`;

  if (isNotUndefined(data.uniqueDays)) {
    text += '\n';
    text += uniqueDaysTextWithType('blood pressure', data.uniqueDays);
  }

  if (croOrDncText(data).trim()) text += `\n${croOrDncText(data)}`;

  if (additionalFollowUpText(data).trim())
    text += `\n${additionalFollowUpText(data)}`;

  if (needEscalateText(data).trim()) text += `\n${needEscalateText(data)}`;

  if (data.freeTextComments?.trim()) text += `\n${data.freeTextComments}. `;

  return text;
};
